// extracted by mini-css-extract-plugin
export default {"icon":"icon-module__icon"};